import createActivityDetector from './activity_detector';
import { getDiffText } from './diff_text';
import { safeSanitize } from './safe_sanitize';

const TIME_TO_IDLE = 2 * 60 * 1000;

const activityDetector = createActivityDetector({timeToIdle: TIME_TO_IDLE});

const CHANNELS = {
  ACTIVITY_LOG: 'ACTIVITY_LOG',
  AUDIT_LOG: 'AUDIT_LOG',
};

window.activityDetector = activityDetector;

window.OpenTheAdvancedEditEvent = function OpenTheAdvancedEditEvent(data) {
  this.page = "LEASE";
  this.key = 'OPEN_THE_ADVANCED_EDIT';
  this.description = 'Open the advanced-edit';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.OpenTheAdvancedEditEvent.key = 'OPEN_THE_ADVANCED_EDIT';

window.InteractWithTheAutomationEvent = function InteractWithTheAutomationEvent(data) {
  this.page = "LEASE";
  this.key = 'INTERACT_WITH_THE_AUTOMATION';
  this.description = 'Deal terms changed';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return this.data.field === otherEvent.data.field;
  }
  this.consolidate = (otherEvent) => {
    return new InteractWithTheAutomationEvent({
      ...this.data,
      value: otherEvent.data.value
    });
  }
  this.format = () => {
    const label = scopeVar.fullLabels[this.data.field] || scopeVar.shortLabels[this.data.field] || this.data.field;
    const value = this.data.value;

    if (value) {
      if (typeof value === 'boolean') {
        if (value) {
          return `Turned on <em>${label}</em>`;
        } else {
          return `Turned off <em>${label}</em>`;
        }
      } else {
        return `Changed <em>${label}</em> to <em>${value}</em>`;
      }
    } else {
      return `Changed <em>${label}</em>`;
    }
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  };
};
window.InteractWithTheAutomationEvent.key = 'INTERACT_WITH_THE_AUTOMATION';

window.UndoEvent = function UndoEvent(data) {
  this.page = "LEASE";
  this.key = 'UNDO';
  this.description = 'Undo';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.UndoEvent.key = 'UNDO';

window.RedoEvent = function RedoEvent(data) {
  this.page = "LEASE";
  this.key = 'REDO';
  this.description = 'Redo';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.RedoEvent.key = 'REDO';

window.CutEvent = function CutEvent(data) {
  this.page = "LEASE";
  this.key = 'CUT';
  this.description = 'Cut';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.CutEvent.key = 'CUT';

window.CopyEvent = function CopyEvent(data) {
  this.page = "LEASE";
  this.key = 'COPY';
  this.description = 'Copy';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.CopyEvent.key = 'COPY';

window.IndentParagraphEvent = function IndentParagraphEvent(data) {
  this.page = "LEASE";
  this.key = 'INDENT_PARAGRAPH';
  this.description = 'Indent paragraph';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.IndentParagraphEvent.key = 'INDENT_PARAGRAPH';

window.AlignParagraphEvent = function AlignParagraphEvent(data) {
  this.page = "LEASE";
  this.key = 'ALIGN_PARAGRAPH';
  this.description = 'Align paragraph';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.AlignParagraphEvent.key = 'ALIGN_PARAGRAPH';

window.HighlightTextWithColorEvent = function HighlightTextWithColorEvent(data) {
  this.page = "LEASE";
  this.key = 'HIGHLIGHT_TEXT_WITH_COLOR';
  this.description = 'Highlight text with color';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.HighlightTextWithColorEvent.key = 'HIGHLIGHT_TEXT_WITH_COLOR';

window.ChangeFontSizeEvent = function ChangeFontSizeEvent(data) {
  this.page = "LEASE";
  this.key = 'CHANGE_FONT_SIZE_EVENT';
  this.description = 'Change font size';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ChangeFontSizeEvent.key = 'CHANGE_FONT_SIZE_EVENT';

window.ChangeLineHeightEvent = function ChangeLineHeightEvent(data) {
  this.page = "LEASE";
  this.key = 'CHANGE_LINE_HEIGHT_EVENT';
  this.description = 'Change line height';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ChangeLineHeightEvent.key = 'CHANGE_LINE_HEIGHT_EVENT';

window.TurnOnControlCharactersEvent = function TurnOnControlCharactersEvent(data) {
  this.page = "LEASE";
  this.key = 'TURN_ON_CONTROL_CHARACTERS';
  this.description = 'Turn on control characters';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.TurnOnControlCharactersEvent.key = 'TURN_ON_CONTROL_CHARACTERS';

window.TurnOffControlCharactersEvent = function TurnOffControlCharactersEvent(data) {
  this.page = "LEASE";
  this.key = 'TURN_OFF_CONTROL_CHARACTERS';
  this.description = 'Turn off control characters';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.TurnOffControlCharactersEvent.key = 'TURN_OFF_CONTROL_CHARACTERS';

window.MoveToThePreviousTenantRequestEvent = function MoveToThePreviousTenantRequestEvent(data) {
  this.page = "LEASE";
  this.key = 'MOVE_TO_THE_PREVIOUS_TENANT_REQUEST';
  this.description = 'Move to the previous tenant request';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.MoveToThePreviousTenantRequestEvent.key = 'MOVE_TO_THE_PREVIOUS_TENANT_REQUEST';

window.MoveToTheNextTenantRequestEvent = function MoveToTheNextTenantRequestEvent(data) {
  this.page = "LEASE";
  this.key = 'MOVE_TO_THE_NEXT_TENANT_REQUEST';
  this.description = 'Move to the next tenant request';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.MoveToTheNextTenantRequestEvent.key = 'MOVE_TO_THE_NEXT_TENANT_REQUEST';

window.OpenTenantRequestEvent = function OpenTenantRequestEvent(data) {
  this.page = "LEASE";
  this.key = 'OPEN_TENANT_REQUEST';
  this.description = 'Open tenant request';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.OpenTenantRequestEvent.key = 'OPEN_TENANT_REQUEST';

window.CloseTenantRequestEvent = function CloseTenantRequestEvent(data) {
  this.page = "LEASE";
  this.key = 'CLOSE_TENANT_REQUEST';
  this.description = 'Close tenant request';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.CloseTenantRequestEvent.key = 'CLOSE_TENANT_REQUEST';

window.EnterAnIndividualTenantRequestEvent = function EnterAnIndividualTenantRequestEvent(data) {
  this.page = "LEASE";
  this.key = 'ENTER_AN_INDIVIDUAL_TENANT_REQUEST';
  this.description = 'Enter an individual tenant request';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.EnterAnIndividualTenantRequestEvent.key = 'ENTER_AN_INDIVIDUAL_TENANT_REQUEST';

window.ExitAnIndividualTenantRequestEvent = function ExitAnIndividualTenantRequestEvent(data) {
  this.page = "LEASE";
  this.key = 'EXIT_AN_INDIVIDUAL_TENANT_REQUEST';
  this.description = 'Exit an individual tenant request';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ExitAnIndividualTenantRequestEvent.key = 'EXIT_AN_INDIVIDUAL_TENANT_REQUEST';

window.FinishReviewOfTenantRequestsEvent = function FinishReviewOfTenantRequestsEvent(data) {
  this.page = "LEASE";
  this.key = 'FINISH_REVIEW_OF_TENANT_REQUESTS';
  this.description = 'Finish review of tenant requests';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.FinishReviewOfTenantRequestsEvent.key = 'FINISH_REVIEW_OF_TENANT_REQUESTS';

window.LoadDocumentEvent = function LoadDocumentEvent(data) {
  this.page = "LEASE";
  this.key = 'LOAD_DOCUMENT';
  this.description = 'Load document';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.LoadDocumentEvent.key = 'LOAD_DOCUMENT';

window.DeleteListItemEvent = function DeleteListItemEvent(data) {
  this.page = "LEASE";
  this.key = 'DELETE_LIST_ITEM';
  this.description = 'Delete list-item';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.DeleteListItemEvent.key = 'DELETE_LIST_ITEM';

window.InsertListItemEvent = function InsertListItemEvent(data) {
  this.page = "LEASE";
  this.key = 'INSERT_LIST_ITEM';
  this.description = 'Insert list-item';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.InsertListItemEvent.key = 'INSERT_LIST_ITEM';

window.LogoutEvent = function LogoutEvent(data) {
  this.page = "";
  this.key = 'LOGOUT';
  this.description = 'Logout';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  };
};
window.LogoutEvent.key = 'LOGOUT';

window.AcceptAllTenantRequestsEvent = function AcceptAllTenantRequestsEvent(data) {
  this.page = "LEASE";
  this.key = 'ACCEPT_ALL_TENANT_REQUESTS';
  this.description = 'Accept all tenant requests';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.AcceptAllTenantRequestsEvent.key = 'ACCEPT_ALL_TENANT_REQUESTS';

window.AcceptIndividualTenantRequestEvent = function AcceptIndividualTenantRequestEvent(data) {
  this.page = "LEASE";
  this.key = 'ACCEPT_INDIVIDUAL_TENANT_REQUEST';
  this.description = 'Accept individual tenant request';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.AcceptIndividualTenantRequestEvent.key = 'ACCEPT_INDIVIDUAL_TENANT_REQUEST';

window.RejectAllTenantRequestsEvent = function RejectAllTenantRequestsEvent(data) {
  this.page = "LEASE";
  this.key = 'REJECT_ALL_TENANT_REQUESTS';
  this.description = 'Reject all tenant requests';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.RejectAllTenantRequestsEvent.key = 'REJECT_ALL_TENANT_REQUESTS';

window.RejectIndividualTenantRequestEvent = function RejectIndividualTenantRequestEvent(data) {
  this.page = "LEASE";
  this.key = 'REJECT_INDIVIDUAL_TENANT_REQUEST';
  this.description = 'Reject individual tenant request';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.RejectIndividualTenantRequestEvent.key = 'REJECT_INDIVIDUAL_TENANT_REQUEST';

window.AdjustAllTenantRequestsManuallyEvent = function AdjustAllTenantRequestsManuallyEvent(data) {
  this.page = "LEASE";
  this.key = 'ADJUST_ALL_TENANT_REQUESTS_MANUALLY';
  this.description = 'Adjust all tenant requests manually';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.AdjustAllTenantRequestsManuallyEvent.key = 'ADJUST_ALL_TENANT_REQUESTS_MANUALLY';

window.AdjustIndividualTenantRequestManuallyEvent = function AdjustIndividualTenantRequestManuallyEvent(data) {
  this.page = "LEASE";
  this.key = 'ADJUST_INDIVIDUAL_TENANT_REQUEST_MANUALLY';
  this.description = 'Adjust individual tenant request manually';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.AdjustIndividualTenantRequestManuallyEvent.key = 'ADJUST_INDIVIDUAL_TENANT_REQUEST_MANUALLY';

window.MarkAllTenantRequestsAsResolvedEvent = function MarkAllTenantRequestsAsResolvedEvent(data) {
  this.page = "LEASE";
  this.key = 'MARK_ALL_TENANT_REQUESTS_AS_RESOLVED';
  this.description = 'Mark all tenant requests as resolved';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.MarkAllTenantRequestsAsResolvedEvent.key = 'MARK_ALL_TENANT_REQUESTS_AS_RESOLVED';

window.MarkIndividualTenantRequestAsResolvedEvent = function MarkIndividualTenantRequestAsResolvedEvent(data) {
  this.page = "LEASE";
  this.key = 'MARK_INDIVIDUAL_TENANT_REQUEST_AS_RESOLVED';
  this.description = 'Mark individual tenant request as resolved';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.MarkIndividualTenantRequestAsResolvedEvent.key = 'MARK_INDIVIDUAL_TENANT_REQUEST_AS_RESOLVED';

window.PreviewTenantRequestsEvent = function PreviewTenantRequestsEvent(data) {
  this.page = "LEASE";
  this.key = 'PREVIEW_TENANT_REQUESTS';
  this.description = 'Preview tenant requests';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.PreviewTenantRequestsEvent.key = 'PREVIEW_TENANT_REQUESTS';

window.CompareDocumentsEvent = function CompareDocumentsEvent(data) {
  this.page = "LEASE";
  this.key = 'COMPARE_DOCUMENTS';
  this.description = 'Document compared';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    if (this.data.original) {
      return `Compared document against <em>${this.data.original}</em>`;
    } else if (this.data.modified) {
      return `Compared <em>${this.data.modified}</em> against document`;
    }
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.CompareDocumentsEvent.key = 'COMPARE_DOCUMENTS';

window.AbstractDocumentEvent = function AbstractDocumentEvent(data) {
  this.page = "LEASE";
  this.key = 'ABSTRACT_DOCUMENT';
  this.description = 'Abstract created';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    if (this.data.fileName) {
      return `Created abstract for <em>${this.data.fileName}</em>`;
    } else {
      return null;
    }
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.AbstractDocumentEvent.key = 'ABSTRACT_DOCUMENT';

window.SaveConformedDealEvent = function SaveConformedDealEvent(data) {
  this.page = "LEASE";
  this.key = 'SAVE_AS_CONFORMED_DEAL';
  this.description = 'Document saved as conformed deal';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.data.name;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.SaveConformedDealEvent.key = 'SAVE_AS_CONFORMED_DEAL';

window.CreateNewConformedDealEvent = function CreateNewConformedDealEvent(data) {
  this.page = "LEASE";
  this.key = 'CREATE_NEW_CONFORMED_DEAL';
  this.description = 'Conformed deal created';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.data?.name;
  };
  this.getObjectId = () => {
    return this.data.id;
  }
}
window.CreateNewConformedDealEvent.key = 'CREATE_NEW_CONFORMED_DEAL';

window.DownloadDocumentEvent = function DownloadDocumentEvent(data) {
  this.page = "LEASE";
  this.key = 'DOWNLOAD_DOCUMENT';
  this.description = 'Document downloaded';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.DownloadDocumentEvent.key = 'DOWNLOAD_DOCUMENT';

window.OpenLeftHandEditorSearchEvent = function OpenLeftHandEditorSearchEvent(data) {
  this.page = "LEASE";
  this.key = 'OPEN_LEFT_HAND_EDITOR_SEARCH';
  this.description = 'Open left-hand editor search';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.OpenLeftHandEditorSearchEvent.key = 'OPEN_LEFT_HAND_EDITOR_SEARCH';

window.HideLeftHandEditorSearchEvent = function HideLeftHandEditorSearchEvent(data) {
  this.page = "LEASE";
  this.key = 'HIDE_LEFT_HAND_EDITOR_SEARCH';
  this.description = 'Hide left-hand editor search';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.HideLeftHandEditorSearchEvent.key = 'HIDE_LEFT_HAND_EDITOR_SEARCH';

window.MoveToThePreviousEditorSearchResultEvent = function MoveToThePreviousEditorSearchResultEvent(data) {
  this.page = "LEASE";
  this.key = 'MOVE_TO_THE_PREVIOUS_EDITOR_SEARCH_RESULT';
  this.description = 'Move to the previous editor search result';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.MoveToThePreviousEditorSearchResultEvent.key = 'MOVE_TO_THE_PREVIOUS_EDITOR_SEARCH_RESULT';

window.MoveToTheNextEditorSearchResultEvent = function MoveToTheNextEditorSearchResultEvent(data) {
  this.page = "LEASE";
  this.key = 'MOVE_TO_THE_NEXT_EDITOR_SEARCH_RESULT';
  this.description = 'Move to the next editor search result';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.MoveToTheNextEditorSearchResultEvent.key = 'MOVE_TO_THE_NEXT_EDITOR_SEARCH_RESULT';

window.OpenFeedbackPaneEvent = function OpenFeedbackPaneEvent(data) {
  this.page = "";
  this.key = 'OPEN_FEEDBACK_PANE';
  this.description = 'Open feedback pane';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  };
};
window.OpenFeedbackPaneEvent.key = 'OPEN_FEEDBACK_PANE';

window.FeedbackSubmittedEvent = function FeedbackSubmittedEvent(data) {
  this.page = "";
  this.key = 'FEEDBACK_SUBMITTED';
  this.description = 'Feedback submitted';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  };
};
window.FeedbackSubmittedEvent.key = 'FEEDBACK_SUBMITTED';

window.OpenContactFormPaneEvent = function OpenContactFormPaneEvent(data) {
  this.page = "";
  this.key = 'OPEN_CONTACT_FORM_PANE';
  this.description = 'Open contact form pane';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  };
};
window.OpenContactFormPaneEvent.key = 'OPEN_CONTACT_FORM_PANE';

window.OpenChangelogPaneEvent = function OpenChangelogPaneEvent(data) {
  this.page = "";
  this.key = 'OPEN_CHANGELOG_PANE';
  this.description = 'Open changelog pane';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  };
};
window.OpenChangelogPaneEvent.key = 'OPEN_CHANGELOG_PANE';

window.ContactFormSubmittedEvent = function ContactFormSubmittedEvent(data) {
  this.page = "";
  this.key = 'CONTACT_FORM_SUBMITTED';
  this.description = 'Contact form submitted';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  };
};
window.ContactFormSubmittedEvent.key = 'CONTACT_FORM_SUBMITTED';

window.ResizeImageEvent = function ResizeImageEvent(data) {
  this.page = "LEASE";
  this.key = 'RESIZE_IMAGE';
  this.description = 'Resize image';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ResizeImageEvent.key = 'RESIZE_IMAGE';

window.RotateImageEvent = function RotateImageEvent(data) {
  this.page = "LEASE";
  this.key = 'ROTATE_IMAGE';
  this.description = 'Rotate image';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.RotateImageEvent.key = 'ROTATE_IMAGE';

window.DeleteImageEvent = function DeleteImageEvent(data) {
  this.page = "LEASE";
  this.key = 'DELETE_IMAGE';
  this.description = 'Delete image';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.DeleteImageEvent.key = 'DELETE_IMAGE';

window.ResetImageToOriginalSizeEvent = function ResetImageToOriginalSizeEvent(data) {
  this.page = "LEASE";
  this.key = 'RESET_IMAGE_TO_ORIGINAL_SIZE';
  this.description = 'Reset image to original size';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ResetImageToOriginalSizeEvent.key = 'RESET_IMAGE_TO_ORIGINAL_SIZE';

window.ImportTenantRequestsEvent = function ImportTenantRequestsEvent(data) {
  this.page = "LEASE";
  this.key = 'IMPORT_TENANT_REQUESTS';
  this.description = 'Import tenant requests';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ImportTenantRequestsEvent.key = 'IMPORT_TENANT_REQUESTS';

window.RulerToggledEvent = function RulerToggledEvent(data) {
  this.page = "";
  this.key = 'RulerToggled';
  this.description = 'Ruler toggled';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.RulerToggledEvent.key = 'RULER_TOGGLED';

window.TabstopAddedEvent = function TabstopAddedEvent(data) {
  this.page = "";
  this.key = 'TabstopAdded';
  this.description = 'Tabstop added';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.TabstopAddedEvent.key = 'TABSTOP_ADDED';

window.TabstopAlignmentChangedEvent = function TabstopAlignmentChangedEvent(data) {
  this.page = "";
  this.key = 'TabstopAlignmentChanged';
  this.description = 'Tabstop alignment changed';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.TabstopAlignmentChangedEvent.key = 'TABSTOP_ALIGNMENT_CHANGED';

window.TabstopLeaderChangedEvent = function TabstopLeaderChangedEvent(data) {
  this.page = "";
  this.key = 'TabstopLeaderChanged';
  this.description = 'Tabstop leader changed';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.TabstopLeaderChangedEvent.key = 'TABSTOP_LEADER_CHANGED';

window.TabstopRemovedEvent = function TabstopRemovedEvent(data) {
  this.page = "";
  this.key = 'TabstopRemoved';
  this.description = 'Tabstop removed';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.TabstopRemovedEvent.key = 'TABSTOP_REMOVED';

window.TabstopMovedEvent = function TabstopMovedEvent(data) {
  this.page = "";
  this.key = 'TabstopMoved';
  this.description = 'Tabstop moved';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.TabstopMovedEvent.key = 'TABSTOP_MOVED';

window.IndentAdjustedEvent = function IndentAdjustedEvent(data) {
  this.page = "";
  this.key = 'IndentAdjusted';
  this.description = 'Indent adjusted';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.IndentAdjustedEvent.key = 'INDENT_ADJUSTED';

window.TabCharacterInsertedEvent = function TabCharacterInsertedEvent(data) {
  this.page = "";
  this.key = 'TabCharacterInserted';
  this.description = 'Tab character inserted';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.TabCharacterInsertedEvent.key = 'TAB_CHARACTER_INSERTED';

window.TabCharacterInsertedEvent = function TabCharacterInsertedEvent(data) {
  this.page = "";
  this.key = 'TabCharacterInserted';
  this.description = 'Tab character inserted';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.TabCharacterInsertedEvent.key = 'TAB_CHARACTER_INSERTED';

window.TabCharacterDeletedEvent = function TabCharacterDeletedEvent(data) {
  this.page = "";
  this.key = 'TabCharacterDeleted';
  this.description = 'Tab character deleted';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.TabCharacterDeletedEvent.key = 'TAB_CHARACTER_DELETED';

window.CreateANewDocumentEvent = function CreateANewDocumentEvent(data) {
  this.page = "";
  this.key = 'CREATE_A_NEW_DOCUMENT';
  this.description = 'Document created';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.CreateANewDocumentEvent.key = 'CREATE_A_NEW_DOCUMENT';

window.DuplicateDocumentEvent = function DuplicateDocumentEvent(data) {
  this.page = "LEASE";
  this.key = 'DUPLICATE_DOCUMENT';
  this.description = 'Document duplicated';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `<a href="${this.data.url}" target="_blank"><em>Click here</em></a> to open the document`;
  };
  this.getObjectId = () => {
    return this.data?.id;
  };
};
window.DuplicateDocumentEvent.key = 'DUPLICATE_DOCUMENT';

window.CreateNewVersionEvent = function CreateNewVersionEvent(data) {
  this.page = "LEASE";
  this.key = 'CREATE_NEW_VERSION';
  this.description = 'New version created';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    if (this.data.description) {
      return `Version ${this.data.version}: ${this.data.description}`;
    } else {
      return `Version ${this.data.version}`;
    }
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.CreateNewVersionEvent.key = 'CREATE_NEW_VERSION';

window.PrintDocumentEvent = function PrintDocumentEvent(data) {
  this.page = "LEASE";
  this.key = 'PRINT_DOCUMENT';
  this.description = 'Document printed';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.PrintDocumentEvent.key = 'PRINT_DOCUMENT';

window.ShareDocumentEvent = function ShareDocumentEvent(data) {
  this.page = "LEASE";
  this.key = 'SHARE_DOCUMENT';
  this.description = 'Document shared';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `${this.data.emails.join()}`;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ShareDocumentEvent.key = 'SHARE_DOCUMENT';

window.ChangeUserEvent = function ChangeUserEvent(data) {
  this.page = "LEASE";
  this.key = 'CHANGE_USER';
  this.description = 'Document assigned to user';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const user = window.users.find(u => u.id === this.data.userId);
    const userName = (user.firstName && user.lastName) ? user.firstName + ' ' + user.lastName : user.email;
    return `${userName}`;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ChangeUserEvent.key = 'CHANGE_USER';

window.ChangeStatusEvent = function ChangeStatusEvent(data) {
  this.page = "LEASE";
  this.key = 'CHANGE_STATUS';
  this.description = 'Status changed';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `${this.data.status}`;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ChangeStatusEvent.key = 'CHANGE_STATUS';

window.SaveChangesUsingTheAdvancedEditEvent = function SaveChangesUsingTheAdvancedEditEvent(data) {
  this.page = "LEASE";
  this.key = 'SAVE_CHANGES_USING_THE_ADVANCED_EDIT';
  this.description = 'Save changes using the advanced-edit';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.SaveChangesUsingTheAdvancedEditEvent.key = 'SAVE_CHANGES_USING_THE_ADVANCED_EDIT';

window.DeleteParagraphEvent = function DeleteParagraphEvent(data) {
  this.page = "LEASE";
  this.key = 'DELETE_PARAGRAPH';
  this.description = 'Delete paragraph';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.DeleteParagraphEvent.key = 'DELETE_PARAGRAPH';

window.ClickOnALeaseVarEvent = function ClickOnALeaseVarEvent(data) {
  this.page = "LEASE";
  this.key = 'CLICK_ON_A_LEASE_VAR';
  this.description = 'Click on a lease-var';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ClickOnALeaseVarEvent.key = 'CLICK_ON_A_LEASE_VAR';

window.ToggleDocumentSearchEvent = function ToggleDocumentSearchEvent(data) {
  this.page = "LEASE";
  this.key = 'TOGGLE_DOCUMENT_SEARCH';
  this.description = 'Toggle document search';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ToggleDocumentSearchEvent.key = 'TOGGLE_DOCUMENT_SEARCH';

window.EnterSoftBreakEvent = function EnterSoftBreakEvent(data) {
  this.page = "LEASE";
  this.key = 'ENTER_SOFT_BREAK';
  this.description = 'Enter soft-break';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.EnterSoftBreakEvent.key = 'ENTER_SOFT_BREAK';

window.EnterHardSpaceEvent = function EnterHardSpaceEvent(data) {
  this.page = "LEASE";
  this.key = 'ENTER_HARD_SPACE';
  this.description = 'Enter hard-space';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.EnterHardSpaceEvent.key = 'ENTER_HARD_SPACE';

window.EnterHardBreakEvent = function EnterHardBreakEvent(data) {
  this.page = "LEASE";
  this.key = 'ENTER_HARD_BREAK';
  this.description = 'Enter hard-break';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.EnterHardBreakEvent.key = 'ENTER_HARD_BREAK';

window.PasteEvent = function PasteEvent(data) {
  this.page = "LEASE";
  this.key = 'PASTE';
  this.description = 'Paste';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.PasteEvent.key = 'PASTE';

window.ReviseTextEvent = function ReviseTextEvent(data) {
  this.page = "LEASE";
  this.key = 'REVISE_TEXT';
  this.description = 'Text revised';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return this.data.pid === otherEvent.data.pid;
  }
  this.consolidate = (otherEvent) => {
    return new ReviseTextEvent({
      ...this.data,
      after: otherEvent.data.after,
    });
  }
  this.format = () => {
    return getDiffText(this.data.before, this.data.after);
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ReviseTextEvent.key = 'REVISE_TEXT';

window.InsertImageEvent = function InsertImageEvent(data) {
  this.page = "LEASE";
  this.key = 'INSERT_IMAGE';
  this.description = 'Insert image';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.InsertImageEvent.key = 'INSERT_IMAGE';

window.InsertPageBreakEvent = function InsertPageBreakEvent(data) {
  this.page = "LEASE";
  this.key = 'INSERT_PAGE_BREAK';
  this.description = 'Insert page-break';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.InsertPageBreakEvent.key = 'INSERT_PAGE_BREAK';

window.DeletePreDefinedPageBreakEvent = function DeletePreDefinedPageBreakEvent(data) {
  this.page = "LEASE";
  this.key = 'DELETE_PRE_DEFINED_PAGE_BREAK';
  this.description = 'Delete pre-defined page-break';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.DeletePreDefinedPageBreakEvent.key = 'DELETE_PRE_DEFINED_PAGE_BREAK';

window.DeleteNewlyAddedPageBreakEvent = function DeleteNewlyAddedPageBreakEvent(data) {
  this.page = "LEASE";
  this.key = 'DELETE_NEWLY_ADDED_PAGE_BREAK';
  this.description = 'Delete newly-added page-break';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.DeleteNewlyAddedPageBreakEvent.key = 'DELETE_NEWLY_ADDED_PAGE_BREAK';

window.InsertOutlineAndListItemEvent = function InsertOutlineAndListItemEvent(data) {
  this.page = "LEASE";
  this.key = 'INSERT_OUTLINE_AND_LIST_ITEM';
  this.description = 'Insert outline and list-item';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.InsertOutlineAndListItemEvent.key = 'INSERT_OUTLINE_AND_LIST_ITEM';

window.ShowConceptTitlesEvent = function ShowConceptTitlesEvent(data) {
  this.page = "LEASE";
  this.key = 'SHOW_CONCEPT_TITLES_EVENT';
  this.description = 'Show concept titles';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ShowConceptTitlesEvent.key = 'SHOW_CONCEPT_TITLES_EVENT';

window.HideConceptTitlesEvent = function HideConceptTitlesEvent(data) {
  this.page = "LEASE";
  this.key = 'HIDE_CONCEPT_TITLES_EVENT';
  this.description = 'Hide concept titles';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.HideConceptTitlesEvent.key = 'HIDE_CONCEPT_TITLES_EVENT';

window.ArchiveDocumentEvent = function ArchiveDocumentEvent(data) {
  this.page = "LEASE";
  this.key = 'ARCHIVE_DOCUMENT';
  this.description = 'Document archived';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.ArchiveDocumentEvent.key = 'ARCHIVE_DOCUMENT';

window.UnarchiveDocumentEvent = function UnarchiveDocumentEvent(data) {
  this.page = "LEASE";
  this.key = 'UNARCHIVE_DOCUMENT';
  this.description = 'Document unarchived';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.UnarchiveDocumentEvent.key = 'UNARCHIVE_DOCUMENT';

window.LoadDashboardEvent = function LoadDashboardEvent(data) {
  this.page = "DASHBOARD";
  this.key = 'LOAD_DASHBOARD';
  this.description = 'Load dashboard';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.LoadDashboardEvent.key = 'LOAD_DASHBOARD';

window.LoadArchiveEvent = function LoadArchiveEvent(data) {
  this.page = "DASHBOARD";
  this.key = 'LOAD_ARCHIVE';
  this.description = 'Load archive';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.LoadArchiveEvent.key = 'LOAD_ARCHIVE';

window.FilterDocumentsEvent = function FilterDocumentsEvent(data) {
  this.page = "DASHBOARD";
  this.key = 'FILTER_DOCUMENTS';
  this.description = 'Filter documents';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.FilterDocumentsEvent.key = 'FILTER_DOCUMENTS';

window.SortDocumentsEvent = function SortDocumentsEvent(data) {
  this.page = "DASHBOARD";
  this.key = 'SORT_DOCUMENTS';
  this.description = 'Sort documents';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.SortDocumentsEvent.key = 'SORT_DOCUMENTS';

window.DownloadBlankFormEvent = function DownloadBlankFormEvent(data) {
  this.page = "DASHBOARD";
  this.key = 'DOWNLOAD_BLANK_FORM';
  this.description = 'Download blank form';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.DownloadBlankFormEvent.key = 'DOWNLOAD_BLANK_FORM';

window.SessionStartEvent = function SessionStartEvent(data) {
  this.page = "";
  this.key = 'SESSION_START';
  this.description = 'Session start';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.SessionStartEvent.key = 'SESSION_START';

window.SessionTimeoutEvent = function SessionTimeoutEvent(data) {
  this.page = "";
  this.key = 'SESSION_TIMEOUT';
  this.description = 'Session timeout';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.SessionTimeoutEvent.key = 'SESSION_TIMEOUT';

window.SessionEndEvent = function SessionEndEvent(data) {
  this.page = "";
  this.key = 'SESSION_END';
  this.description = 'Session end';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.SessionEndEvent.key = 'SESSION_END';

window.ChangeLevelEvent = function ChangeLevelEvent(data) {
  this.page = "LEASE";
  this.key = 'CHANGE_LEVEL';
  this.description = 'Heading changed';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return this.data.pid === otherEvent.data.pid;
  }
  this.consolidate = (otherEvent) => {
    return new ChangeLevelEvent({
      ...this.data,
      after: otherEvent.data.after,
    });
  }
  this.format = () => {
    return getDiffText(this.data.before, this.data.after);
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.ChangeLevelEvent.key = 'CHANGE_LEVEL';

// =====================
// Clausebook events
// =====================

window.SignUpToClausebook = function SignUpToClausebook(data) {
  this.page = "CLAUSEBOOK";
  this.key = 'SIGN_UP_TO_CLAUSEBOOK';
  this.description = 'Sign up to clausebook';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.SignUpToClausebook.key = 'SIGN_UP_TO_CLAUSEBOOK';

window.CaptureClauseEvent = function CaptureClauseEvent(data) {
  this.page = "CLAUSEBOOK";
  this.key = 'CAPTURE_CLAUSE';
  this.description = 'Capture clause';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.CaptureClauseEvent.key = 'CAPTURE_CLAUSE';

window.InsertClauseEvent = function InsertClauseEvent(data) {
  this.page = "CLAUSEBOOK";
  this.key = 'INSERT_CLAUSE';
  this.description = 'Clause inserted';
  this.channel = CHANNELS.ACTIVITY_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.data.clause;
  };
  this.getObjectId = () => {
    let documentId;

    if (window.lease) {
      documentId = window.lease.id;
    } else if (this.data.id) {
      documentId = this.data.id;
    }

    return documentId;
  }
};
window.InsertClauseEvent.key = 'INSERT_CLAUSE';

window.PreviewClauseEvent = function PreviewClauseEvent(data) {
  this.page = "CLAUSEBOOK";
  this.key = 'PREVIEW_CLAUSE';
  this.description = 'Preview clause';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.PreviewClauseEvent.key = 'PREVIEW_CLAUSE';

// TODO: User Management events
// - Load User Management
window.LoadUserManagementEvent = function LoadUserManagementEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'LOAD_USER_MANAGEMENT';
  this.description = 'Load user management';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.LoadUserManagementEvent.key = 'LOAD_USER_MANAGEMENT';

window.LoadCreateNewUserEvent = function LoadCreateNewUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'LOAD_CREATE_NEW_USER';
  this.description = 'Load create new user';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.LoadCreateNewUserEvent.key = 'LOAD_CREATE_NEW_USER';

window.CreateNewUserEvent = function CreateNewUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'CREATE_NEW_USER';
  this.description = 'New user created';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const user = window.users.find(u => u.id === parseInt(this.data.id));

    let userName = null;
    if (user) {
      userName = (user.firstName && user.lastName) ? user.firstName + ' ' + user.lastName : user.email;
    } else {
      userName = (this.data.firstName && this.data.lastName) ? this.data.firstName + ' ' + this.data.lastName : this.data.email;
    }
    
    return userName;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.CreateNewUserEvent.key = 'CREATE_NEW_USER';

window.CancelCreateNewUserEvent = function CancelCreateNewUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'CANCEL_CREATE_NEW_USER';
  this.description = 'Cancel create new user';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.CancelCreateNewUserEvent.key = 'CANCEL_CREATE_NEW_USER';

window.LoadEditUserEvent = function LoadEditUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'LOAD_EDIT_USER';
  this.description = 'Load edit user';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.LoadEditUserEvent.key = 'LOAD_EDIT_USER';

window.EditUserEvent = function EditUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'EDIT_USER';
  this.description = 'User updated';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const user = window.users.find(u => u.id === parseInt(this.data.id));

    let userName = null;
    if (user) {
      userName = (user.firstName && user.lastName) ? user.firstName + ' ' + user.lastName : user.email;
    } else {
      userName = (this.data.firstName && this.data.lastName) ? this.data.firstName + ' ' + this.data.lastName : this.data.email;
    }
    
    return userName;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.EditUserEvent.key = 'EDIT_USER';

window.CancelEditUserEvent = function CancelEditUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'CANCEL_EDIT_USER';
  this.description = 'Cancel edit user';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.CancelEditUserEvent.key = 'CANCEL_EDIT_USER';

window.ResetPasswordEvent = function ResetPasswordEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'RESET_PASSWORD';
  this.description = 'Password reset';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const user = window.users.find(u => u.id === parseInt(this.data.id));

    let userName = null;
    if (user) {
      userName = (user.firstName && user.lastName) ? user.firstName + ' ' + user.lastName : user.email;
    } else {
      userName = (this.data.firstName && this.data.lastName) ? this.data.firstName + ' ' + this.data.lastName : this.data.email;
    }
    
    return userName;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.ResetPasswordEvent.key = 'RESET_PASSWORD';

window.CancelResetPasswordEvent = function CancelResetPasswordEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'CANCEL_RESET_PASSWORD';
  this.description = 'Cancel reset password';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.CancelResetPasswordEvent.key = 'CANCEL_RESET_PASSWORD';

window.DeleteUserEvent = function DeleteUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'DELETE_USER';
  this.description = 'User deleted';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const userName = (this.data.firstName && this.data.lastName) ? this.data.firstName + ' ' + this.data.lastName : this.data.email;
    return userName;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.DeleteUserEvent.key = 'DELETE_USER';

window.CancelDeleteUserEvent = function CancelDeleteUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'CANCEL_DELETE_USER';
  this.description = 'Cancel delete user';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.CancelDeleteUserEvent.key = 'CANCEL_DELETE_USER';

window.DeactivateUserEvent = function DeactivateUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'DEACTIVATE_USER';
  this.description = 'User deactivated';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const user = window.users.find(u => u.id === parseInt(this.data.id));

    let userName = null;
    if (user) {
      userName = (user.firstName && user.lastName) ? user.firstName + ' ' + user.lastName : user.email;
    } else {
      userName = (this.data.firstName && this.data.lastName) ? this.data.firstName + ' ' + this.data.lastName : this.data.email;
    }
    
    return userName;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.DeactivateUserEvent.key = 'DEACTIVATE_USER';

window.ActivateUserEvent = function ActivateUserEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'ACTIVATE_USER';
  this.description = 'User activated';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const user = window.users.find(u => u.id === parseInt(this.data.id));

    let userName = null;
    if (user) {
      userName = (user.firstName && user.lastName) ? user.firstName + ' ' + user.lastName : user.email;
    } else {
      userName = (this.data.firstName && this.data.lastName) ? this.data.firstName + ' ' + this.data.lastName : this.data.email;
    }
    
    return userName;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.ActivateUserEvent.key = 'ACTIVATE_USER';

window.GeneratePasswordEvent = function GeneratePasswordEvent(data) {
  this.page = "USER_MANAGEMENT";
  this.key = 'GENERATE_PASSWORD';
  this.description = 'Generate password';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.GeneratePasswordEvent.key = 'GENERATE_PASSWORD';

window.LoadBuildingManagementEvent = function LoadBuildingManagementEvent(data) {
  this.page = "BUILDING_MANAGEMENT";
  this.key = 'LOAD_BUILDING_MANAGEMENT';
  this.description = 'Load building management';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.LoadBuildingManagementEvent.key = 'LOAD_BUILDING_MANAGEMENT';

window.LoadEditBuildingEvent = function LoadEditBuildingEvent(data) {
  this.page = "BUILDING_MANAGEMENT";
  this.key = 'LOAD_EDIT_BUILDING';
  this.description = 'Load edit building';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return this.data.id;
  }
};
window.LoadEditBuildingEvent.key = 'LOAD_EDIT_BUILDING';

window.EditBuildingEvent = function EditBuildingEvent(data) {
  this.page = "BUILDING_MANAGEMENT";
  this.key = 'EDIT_BUILDING';
  this.description = 'Building updated';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    let changes = [];

    if (this.data?.before?.displayName !== this.data?.after?.displayName) {
      changes.push(`Display Name: ${getDiffText(this.data.before.displayName, this.data.after.displayName)}`);
    }
    if (this.data?.before?.dashboardName !== this.data?.after?.dashboardName) {
      changes.push(`Dashboard Name: ${getDiffText(this.data.before.dashboardName, this.data.after.dashboardName)}`);
    }
    if (this.data?.before?.landlordName !== this.data?.after?.landlordName) {
      changes.push(`Landlord Name: ${getDiffText(this.data.before.landlordName, this.data.after.landlordName)}`);
    }
    if (this.data?.before?.landlordEntityType !== this.data?.after?.landlordEntityType) {
      changes.push(`Landlord Entity Type: ${getDiffText(this.data.before.landlordEntityType, this.data.after.landlordEntityType)}`);
    }
    if (this.data?.before?.landlordStateOfFormation !== this.data?.after?.landlordStateOfFormation) {
      changes.push(`Landlord State of Formation: ${getDiffText(this.data.before.landlordStateOfFormation, this.data.after.landlordStateOfFormation)}`);
    }
    if (this.data?.before?.streetAddress !== this.data?.after?.streetAddress) {
      changes.push(`Street Address: ${getDiffText(this.data.before.streetAddress, this.data.after.streetAddress)}`);
    }
    if (this.data?.before?.city !== this.data?.after?.city) {
      changes.push(`City: ${getDiffText(this.data.before.city, this.data.after.city)}`);
    }
    if (this.data?.before?.county !== this.data?.after?.county) {
      changes.push(`County: ${getDiffText(this.data.before.county, this.data.after.county)}`);
    }
    if (this.data?.before?.state !== this.data?.after?.state) {
      changes.push(`State: ${getDiffText(this.data.before.state, this.data.after.state)}`);
    }
    if (this.data?.before?.zipCode !== this.data?.after?.zipCode) {
      changes.push(`Zip Code: ${getDiffText(this.data.before.zipCode, this.data.after.zipCode)}`);
    }
    if (this.data?.before?.municipalityType !== this.data?.after?.municipalityType) {
      changes.push(`Municipality Type: ${getDiffText(this.data.before.municipalityType, this.data.after.municipalityType)}`);
    }
    if (this.data?.before?.buildingOfficeArea !== this.data?.after?.buildingOfficeArea) {
      changes.push(`Building Office Area: ${getDiffText(this.data.before.buildingOfficeArea, this.data.after.buildingOfficeArea)}`);
    }
    
    return changes.length > 0 ? changes.join('\n') : 'No changes made';
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.EditBuildingEvent.key = 'EDIT_BUILDING';

window.CancelEditBuildingEvent = function CancelEditBuildingEvent(data) {
  this.page = "BUILDING_MANAGEMENT";
  this.key = 'CANCEL_EDIT_BUILDING';
  this.description = 'Cancel edit building';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.CancelEditBuildingEvent.key = 'CANCEL_EDIT_BUILDING';

window.DeleteBuildingEvent = function DeleteBuildingEvent(data) {
  this.page = "BUILDING_MANAGEMENT";
  this.key = 'DELETE_BUILDING';
  this.description = 'Building deleted';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.data.name;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.DeleteBuildingEvent.key = 'DELETE_BUILDING';

window.CancelDeleteBuildingEvent = function CancelDeleteBuildingEvent(data) {
  this.page = "BUILDING_MANAGEMENT";
  this.key = 'CANCEL_DELETE_BUILDING';
  this.description = 'Cancel delete building';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.CancelDeleteBuildingEvent.key = 'CANCEL_DELETE_BUILDING';

window.LoadFormManagementEvent = function LoadFormManagementEvent(data) {
  this.page = "FORM_MANAGEMENT";
  this.key = 'LOAD_FORM_MANAGEMENT';
  this.description = 'Load form management';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.LoadFormManagementEvent.key = 'LOAD_FORM_MANAGEMENT';

window.SaveFormManagementChangesAsDraftEvent = function SaveDraftEvent(data) {
  this.page = "FORM_MANAGEMENT";
  this.key = 'SAVE_FORM_MANAGER_CHANGES_AS_DRAFT';
  this.description = 'Form manager changes saved as draft';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.data?.name;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.SaveFormManagementChangesAsDraftEvent.key = 'SAVE_FORM_MANAGER_CHANGES_AS_DRAFT';

window.PublishFormManagementChangesEvent = function PublishDraftEvent(data) {
  this.page = "FORM_MANAGEMENT";
  this.key = 'PUBLISH_FORM_MANAGER_CHANGES';
  this.description = 'Form manager changes published';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.PublishFormManagementChangesEvent.key = 'PUBLISH_FORM_MANAGER_CHANGES';

window.CancelFormManagementChangesEvent = function CancelDraftEvent(data) {
  this.page = "FORM_MANAGEMENT";
  this.key = 'CANCEL_FORM_MANAGER_CHANGES';
  this.description = 'Form manager changes discarded';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.data?.name;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.CancelFormManagementChangesEvent.key = 'CANCEL_FORM_MANAGER_CHANGES';

window.LoadPartnerManagementEvent = function LoadPartnerManagementEvent(data) {
  this.page = "PARTNER_MANAGEMENT";
  this.key = 'LOAD_PARTNER_MANAGEMENT';
  this.description = 'Load partner management';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.LoadPartnerManagementEvent.key = 'LOAD_PARTNER_MANAGEMENT';

window.LoadAssignBuildingsToPartnerEvent = function LoadAssignBuildingsToPartnerEvent(data) {
  this.page = "PARTNER_MANAGEMENT";
  this.key = 'LOAD_ASSIGN_BUILDINGS_TO_PARTNER';
  this.description = 'Load assign buildings to partner';
  this.channel = null;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return this.description;
  };
  this.getObjectId = () => {
    return null;
  }
};
window.LoadAssignBuildingsToPartnerEvent.key = 'LOAD_ASSIGN_BUILDINGS_TO_PARTNER';

window.AssignBuildingsEvent = function AssignBuildingsEvent(data) {
  this.page = "PARTNER_MANAGEMENT";
  this.key = 'ASSIGN_BUILDINGS';
  this.description = 'Building assigned to partner';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const buildingNames = this.data?.buildings?.map(building => building.name);
    const partnerName = this.data?.partner?.name;
    let result = `Assigned buildings to ${partnerName}:\n`;
    
    buildingNames.forEach(buildingName => {
      result += `- ${buildingName}\n`;
    });

    return result;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
};
window.AssignBuildingsEvent.key = 'ASSIGN_BUILDINGS';

window.UnassignBuildingsEvent = function UnassignBuildingsEvent(data) {
  this.page = "PARTNER_MANAGEMENT";
  this.key = 'UNASSIGN_BUILDINGS';
  this.description = 'Building unassigned from partner';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const buildingNames = this.data?.buildings?.map(building => building.name);
    const partnerName = this.data?.partner?.name;
    let result = `Unassigned buildings from ${partnerName}:\n`;
    
    buildingNames.forEach(buildingName => {
      result += `- ${buildingName}\n`;
    });

    return result;
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
}
window.UnassignBuildingsEvent.key = 'UNASSIGN_BUILDINGS';

// Security events

window.GenerateNewApiTokenEvent = function GenerateNewApiTokenEvent(data) {
  this.page = "API";
  this.key = 'GENERATE_NEW_API_TOKEN';
  this.description = 'New API token generated';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return "";
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
}
window.GenerateNewApiTokenEvent.key = 'GENERATE_NEW_API_TOKEN';

window.IPRestrictionsChangedEvent = function IPRestrictionsChangedEvent(data) {
  this.page = "SECURITY";
  this.key = 'IP_RESTRICTIONS_CHANGED';
  this.description = 'IP restrictions changed';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    if (this.data?.ipFilter) {
      return getDiffText(this.data.before, this.data.after);
    }

    return "IP restrictions disabled";
  };
  this.getObjectId = () => {
    return this.data?.id;
  }
}
window.IPRestrictionsChangedEvent.key = 'IP_RESTRICTIONS_CHANGED';

// lp-013 section 4, and lp-014's export.
//
// A playbook is company policy, and everywhere else in this product a change to
// something that governs other people's work lands in the audit trail as an
// append-only event. There was no reason for this one surface to invent its own
// record, so it does not: same channel, same shape, same page grouping as user
// management and IP restrictions.
//
// Each of these is CONFIRMING or IMPORTING, never editing. Typing in a field is
// not an event — a draft is not policy, and logging every keystroke would bury
// the six moments that actually change what drafters are told. `compare`
// returns false throughout for the same reason: two confirmations of two
// concepts are two facts, and consolidating them would lose which was which.

window.PlaybookSavedEvent = function PlaybookSavedEvent(data) {
  this.page = "PLAYBOOKS";
  this.key = 'PLAYBOOK_SAVED';
  this.description = 'Playbook saved';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `${this.data?.documentType || 'Playbook'} — ${this.data?.declaredCount || 0} confirmed, ${this.data?.draftCount || 0} still a draft`;
  };
  this.getObjectId = () => {
    return this.data?.concept || this.data?.documentType;
  }
}
window.PlaybookSavedEvent.key = 'PLAYBOOK_SAVED';

window.PlaybookPositionConfirmedEvent = function PlaybookPositionConfirmedEvent(data) {
  this.page = "PLAYBOOKS";
  this.key = 'PLAYBOOK_POSITION_CONFIRMED';
  this.description = 'Playbook position confirmed';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `${this.data?.conceptLabel || this.data?.concept}`;
  };
  this.getObjectId = () => {
    return this.data?.concept || this.data?.documentType;
  }
}
window.PlaybookPositionConfirmedEvent.key = 'PLAYBOOK_POSITION_CONFIRMED';

window.PlaybookPositionDeclinedEvent = function PlaybookPositionDeclinedEvent(data) {
  this.page = "PLAYBOOKS";
  this.key = 'PLAYBOOK_POSITION_DECLINED';
  this.description = 'Playbook position declined';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `${this.data?.conceptLabel || this.data?.concept} — no position, by choice`;
  };
  this.getObjectId = () => {
    return this.data?.concept || this.data?.documentType;
  }
}
window.PlaybookPositionDeclinedEvent.key = 'PLAYBOOK_POSITION_DECLINED';

window.PlaybookWrittenPlaybookImportedEvent = function PlaybookWrittenPlaybookImportedEvent(data) {
  this.page = "PLAYBOOKS";
  this.key = 'PLAYBOOK_WRITTEN_PLAYBOOK_IMPORTED';
  this.description = 'Written playbook imported';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    // Not the filename. A firm names these after the counterparty or the
    // property, and this channel leaves the tenant.
    const many = this.data?.fileCount > 1 ? `${this.data.fileCount} documents` : 'A written playbook';
    return `${many} — ${this.data?.entryCount || 0} positions read`;
  };
  this.getObjectId = () => {
    return this.data?.concept || this.data?.documentType;
  }
}
window.PlaybookWrittenPlaybookImportedEvent.key = 'PLAYBOOK_WRITTEN_PLAYBOOK_IMPORTED';

window.PlaybookFormReadEvent = function PlaybookFormReadEvent(data) {
  this.page = "PLAYBOOKS";
  this.key = 'PLAYBOOK_FORM_READ';
  this.description = 'Form positions read into playbook';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `${this.data?.conceptCount || 0} concepts read from the form`;
  };
  this.getObjectId = () => {
    return this.data?.concept || this.data?.documentType;
  }
}
window.PlaybookFormReadEvent.key = 'PLAYBOOK_FORM_READ';

window.PlaybookNegotiationsImportedEvent = function PlaybookNegotiationsImportedEvent(data) {
  this.page = "PLAYBOOKS";
  this.key = 'PLAYBOOK_NEGOTIATIONS_IMPORTED';
  this.description = 'Past negotiations imported';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `${this.data?.dealCount || 0} deals imported`;
  };
  this.getObjectId = () => {
    return this.data?.concept || this.data?.documentType;
  }
}
window.PlaybookNegotiationsImportedEvent.key = 'PLAYBOOK_NEGOTIATIONS_IMPORTED';

window.PlaybookExportedEvent = function PlaybookExportedEvent(data) {
  this.page = "PLAYBOOKS";
  this.key = 'PLAYBOOK_EXPORTED';
  this.description = 'Playbook exported to Word';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    return `${this.data?.template ? 'Blank template' : 'Playbook'} — ${this.data?.documentType || ''}`;
  };
  this.getObjectId = () => {
    return this.data?.concept || this.data?.documentType;
  }
}
window.PlaybookExportedEvent.key = 'PLAYBOOK_EXPORTED';

// lp-016 §5. A pre-send check whose decisions nobody can account for is a
// personal tool. These two are what make it a firm's process: "who decided to
// leave that blank in, and when" had no answer before them.
//
// Set aside is the whole decision — on a playbook finding it is somebody
// knowingly overriding their own floor — so the format line carries the finding
// itself rather than its id, which means something to a reviewer reading the
// log a month later.
window.CheckFindingSetAsideEvent = function CheckFindingSetAsideEvent(data) {
  this.page = "LEASE";
  this.key = 'CHECK_FINDING_SET_ASIDE';
  this.description = 'Check finding set aside';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const where = this.data?.sectionNumber ? ` (${this.data.sectionNumber})` : '';
    // The finding's REFERENCE, not its text. This channel is forwarded off
    // platform, and a finding's own words carry the document and — on a
    // playbook finding — the firm's declared floor.
    return `${this.data?.severity || ''} — ${this.data?.finding || ''}${where}`.trim();
  };
  this.getObjectId = () => {
    return this.data?.documentId || (window.lease && window.lease.id);
  }
}
window.CheckFindingSetAsideEvent.key = 'CHECK_FINDING_SET_ASIDE';

window.CheckFindingReopenedEvent = function CheckFindingReopenedEvent(data) {
  this.page = "LEASE";
  this.key = 'CHECK_FINDING_REOPENED';
  this.description = 'Check finding reopened';
  this.channel = CHANNELS.AUDIT_LOG;
  this.data = data;
  this.compare = (otherEvent) => {
    return false;
  }
  this.consolidate = (otherEvent) => {
    return this;
  }
  this.format = () => {
    const where = this.data?.sectionNumber ? ` (${this.data.sectionNumber})` : '';
    return `${this.data?.finding || ''}${where} — back on the list`.trim();
  };
  this.getObjectId = () => {
    return this.data?.documentId || (window.lease && window.lease.id);
  }
}
window.CheckFindingReopenedEvent.key = 'CHECK_FINDING_REOPENED';

window.Events = [];
window.Events[window.OpenTheAdvancedEditEvent.key] = window.OpenTheAdvancedEditEvent;
window.Events[window.InteractWithTheAutomationEvent.key] = window.InteractWithTheAutomationEvent;
window.Events[window.UndoEvent.key] = window.UndoEvent;
window.Events[window.RedoEvent.key] = window.RedoEvent;
window.Events[window.CutEvent.key] = window.CutEvent;
window.Events[window.CopyEvent.key] = window.CopyEvent;
window.Events[window.IndentParagraphEvent.key] = window.IndentParagraphEvent;
window.Events[window.AlignParagraphEvent.key] = window.AlignParagraphEvent;
window.Events[window.HighlightTextWithColorEvent.key] = window.HighlightTextWithColorEvent;
window.Events[window.ChangeFontSizeEvent.key] = window.ChangeFontSizeEvent;
window.Events[window.ChangeLineHeightEvent.key] = window.ChangeLineHeightEvent;
window.Events[window.TurnOnControlCharactersEvent.key] = window.TurnOnControlCharactersEvent;
window.Events[window.TurnOffControlCharactersEvent.key] = window.TurnOffControlCharactersEvent;
window.Events[window.MoveToThePreviousTenantRequestEvent.key] = window.MoveToThePreviousTenantRequestEvent;
window.Events[window.MoveToTheNextTenantRequestEvent.key] = window.MoveToTheNextTenantRequestEvent;
window.Events[window.OpenTenantRequestEvent.key] = window.OpenTenantRequestEvent;
window.Events[window.CloseTenantRequestEvent.key] = window.CloseTenantRequestEvent;
window.Events[window.EnterAnIndividualTenantRequestEvent.key] = window.EnterAnIndividualTenantRequestEvent;
window.Events[window.ExitAnIndividualTenantRequestEvent.key] = window.ExitAnIndividualTenantRequestEvent;
window.Events[window.FinishReviewOfTenantRequestsEvent.key] = window.FinishReviewOfTenantRequestsEvent;
window.Events[window.LoadDocumentEvent.key] = window.LoadDocumentEvent;
window.Events[window.DeleteListItemEvent.key] = window.DeleteListItemEvent;
window.Events[window.InsertListItemEvent.key] = window.InsertListItemEvent;
window.Events[window.LogoutEvent.key] = window.LogoutEvent;
window.Events[window.AcceptAllTenantRequestsEvent.key] = window.AcceptAllTenantRequestsEvent;
window.Events[window.AcceptIndividualTenantRequestEvent.key] = window.AcceptIndividualTenantRequestEvent;
window.Events[window.RejectAllTenantRequestsEvent.key] = window.RejectAllTenantRequestsEvent;
window.Events[window.RejectIndividualTenantRequestEvent.key] = window.RejectIndividualTenantRequestEvent;
window.Events[window.AdjustAllTenantRequestsManuallyEvent.key] = window.AdjustAllTenantRequestsManuallyEvent;
window.Events[window.AdjustIndividualTenantRequestManuallyEvent.key] = window.AdjustIndividualTenantRequestManuallyEvent;
window.Events[window.MarkAllTenantRequestsAsResolvedEvent.key] = window.MarkAllTenantRequestsAsResolvedEvent;
window.Events[window.MarkIndividualTenantRequestAsResolvedEvent.key] = window.MarkIndividualTenantRequestAsResolvedEvent;
window.Events[window.PreviewTenantRequestsEvent.key] = window.PreviewTenantRequestsEvent;
window.Events[window.CompareDocumentsEvent.key] = window.CompareDocumentsEvent;
window.Events[window.AbstractDocumentEvent.key] = window.AbstractDocumentEvent;
window.Events[window.DownloadDocumentEvent.key] = window.DownloadDocumentEvent;
window.Events[window.OpenLeftHandEditorSearchEvent.key] = window.OpenLeftHandEditorSearchEvent;
window.Events[window.HideLeftHandEditorSearchEvent.key] = window.HideLeftHandEditorSearchEvent;
window.Events[window.MoveToThePreviousEditorSearchResultEvent.key] = window.MoveToThePreviousEditorSearchResultEvent;
window.Events[window.MoveToTheNextEditorSearchResultEvent.key] = window.MoveToTheNextEditorSearchResultEvent;
window.Events[window.OpenFeedbackPaneEvent.key] = window.OpenFeedbackPaneEvent;
window.Events[window.FeedbackSubmittedEvent.key] = window.FeedbackSubmittedEvent;
window.Events[window.OpenContactFormPaneEvent.key] = window.OpenContactFormPaneEvent;
window.Events[window.OpenChangelogPaneEvent.key] = window.OpenChangelogPaneEvent;
window.Events[window.ContactFormSubmittedEvent.key] = window.ContactFormSubmittedEvent;
window.Events[window.ResizeImageEvent.key] = window.ResizeImageEvent;
window.Events[window.RotateImageEvent.key] = window.RotateImageEvent;
window.Events[window.DeleteImageEvent.key] = window.DeleteImageEvent;
window.Events[window.ResetImageToOriginalSizeEvent.key] = window.ResetImageToOriginalSizeEvent;
window.Events[window.ImportTenantRequestsEvent.key] = window.ImportTenantRequestsEvent;
window.Events[window.RulerToggledEvent.key] = window.RulerToggledEvent;
window.Events[window.TabstopAddedEvent.key] = window.TabstopAddedEvent;
window.Events[window.TabstopAlignmentChangedEvent.key] = window.TabstopAlignmentChangedEvent;
window.Events[window.TabstopLeaderChangedEvent.key] = window.TabstopLeaderChangedEvent;
window.Events[window.TabstopRemovedEvent.key] = window.TabstopRemovedEvent;
window.Events[window.TabstopMovedEvent.key] = window.TabstopMovedEvent;
window.Events[window.IndentAdjustedEvent.key] = window.IndentAdjustedEvent;
window.Events[window.TabCharacterInsertedEvent.key] = window.TabCharacterInsertedEvent;
window.Events[window.TabCharacterDeletedEvent.key] = window.TabCharacterDeletedEvent;
window.Events[window.CreateANewDocumentEvent.key] = window.CreateANewDocumentEvent;
window.Events[window.DuplicateDocumentEvent.key] = window.DuplicateDocumentEvent;
window.Events[window.CreateNewVersionEvent.key] = window.CreateNewVersionEvent;
window.Events[window.PrintDocumentEvent.key] = window.PrintDocumentEvent;
window.Events[window.ShareDocumentEvent.key] = window.ShareDocumentEvent;
window.Events[window.ChangeUserEvent.key] = window.ChangeUserEvent;
window.Events[window.ChangeStatusEvent.key] = window.ChangeStatusEvent;
window.Events[window.SaveChangesUsingTheAdvancedEditEvent.key] = window.SaveChangesUsingTheAdvancedEditEvent;
window.Events[window.DeleteParagraphEvent.key] = window.DeleteParagraphEvent;
window.Events[window.ClickOnALeaseVarEvent.key] = window.ClickOnALeaseVarEvent;
window.Events[window.ToggleDocumentSearchEvent.key] = window.ToggleDocumentSearchEvent;
window.Events[window.EnterSoftBreakEvent.key] = window.EnterSoftBreakEvent;
window.Events[window.EnterHardSpaceEvent.key] = window.EnterHardSpaceEvent;
window.Events[window.EnterHardBreakEvent.key] = window.EnterHardBreakEvent;
window.Events[window.PasteEvent.key] = window.PasteEvent;
window.Events[window.ReviseTextEvent.key] = window.ReviseTextEvent;
window.Events[window.InsertImageEvent.key] = window.InsertImageEvent;
window.Events[window.InsertPageBreakEvent.key] = window.InsertPageBreakEvent;
window.Events[window.DeletePreDefinedPageBreakEvent.key] = window.DeletePreDefinedPageBreakEvent;
window.Events[window.DeleteNewlyAddedPageBreakEvent.key] = window.DeleteNewlyAddedPageBreakEvent;
window.Events[window.InsertOutlineAndListItemEvent.key] = window.InsertOutlineAndListItemEvent;
window.Events[window.ShowConceptTitlesEvent.key] = window.ShowConceptTitlesEvent;
window.Events[window.HideConceptTitlesEvent.key] = window.HideConceptTitlesEvent;
window.Events[window.ArchiveDocumentEvent.key] = window.ArchiveDocumentEvent;
window.Events[window.UnarchiveDocumentEvent.key] = window.UnarchiveDocumentEvent;
window.Events[window.LoadDashboardEvent.key] = window.LoadDashboardEvent;
window.Events[window.LoadArchiveEvent.key] = window.LoadArchiveEvent;
window.Events[window.FilterDocumentsEvent.key] = window.FilterDocumentsEvent;
window.Events[window.SortDocumentsEvent.key] = window.SortDocumentsEvent;
window.Events[window.DownloadBlankFormEvent.key] = window.DownloadBlankFormEvent;
window.Events[window.SessionStartEvent.key] = window.SessionStartEvent;
window.Events[window.SessionTimeoutEvent.key] = window.SessionTimeoutEvent;
window.Events[window.SessionEndEvent.key] = window.SessionEndEvent;
window.Events[window.ChangeLevelEvent.key] = window.ChangeLevelEvent;
window.Events[window.SignUpToClausebook.key] = window.SignUpToClausebook;
window.Events[window.CaptureClauseEvent.key] = window.CaptureClauseEvent;
window.Events[window.InsertClauseEvent.key] = window.InsertClauseEvent;
window.Events[window.PreviewClauseEvent.key] = window.PreviewClauseEvent;
window.Events[window.LoadUserManagementEvent.key] = window.LoadUserManagementEvent;
window.Events[window.LoadCreateNewUserEvent.key] = window.LoadCreateNewUserEvent;
window.Events[window.CreateNewUserEvent.key] = window.CreateNewUserEvent;
window.Events[window.CancelCreateNewUserEvent.key] = window.CancelCreateNewUserEvent;
window.Events[window.LoadEditUserEvent.key] = window.LoadEditUserEvent;
window.Events[window.EditUserEvent.key] = window.EditUserEvent;
window.Events[window.CancelEditUserEvent.key] = window.CancelEditUserEvent;
window.Events[window.ResetPasswordEvent.key] = window.ResetPasswordEvent;
window.Events[window.CancelResetPasswordEvent.key] = window.CancelResetPasswordEvent;
window.Events[window.DeleteUserEvent.key] = window.DeleteUserEvent;
window.Events[window.CancelDeleteUserEvent.key] = window.CancelDeleteUserEvent;
window.Events[window.DeactivateUserEvent.key] = window.DeactivateUserEvent;
window.Events[window.ActivateUserEvent.key] = window.ActivateUserEvent;
window.Events[window.GeneratePasswordEvent.key] = window.GeneratePasswordEvent;
window.Events[window.LoadBuildingManagementEvent.key] = window.LoadBuildingManagementEvent;
window.Events[window.LoadEditBuildingEvent.key] = window.LoadEditBuildingEvent;
window.Events[window.EditBuildingEvent.key] = window.EditBuildingEvent;
window.Events[window.CancelEditBuildingEvent.key] = window.CancelEditBuildingEvent;
window.Events[window.DeleteBuildingEvent.key] = window.DeleteBuildingEvent;
window.Events[window.CancelDeleteBuildingEvent.key] = window.CancelDeleteBuildingEvent;
window.Events[window.LoadFormManagementEvent.key] = window.LoadFormManagementEvent;
window.Events[window.SaveFormManagementChangesAsDraftEvent.key] = window.SaveFormManagementChangesAsDraftEvent;
window.Events[window.PublishFormManagementChangesEvent.key] = window.PublishFormManagementChangesEvent;
window.Events[window.CancelFormManagementChangesEvent.key] = window.CancelFormManagementChangesEvent;
window.Events[window.LoadPartnerManagementEvent.key] = window.LoadPartnerManagementEvent;
window.Events[window.LoadAssignBuildingsToPartnerEvent.key] = window.LoadAssignBuildingsToPartnerEvent;
window.Events[window.AssignBuildingsEvent.key] = window.AssignBuildingsEvent;
window.Events[window.UnassignBuildingsEvent.key] = window.UnassignBuildingsEvent;
window.Events[window.GenerateNewApiTokenEvent.key] = window.GenerateNewApiTokenEvent;
window.Events[window.IPRestrictionsChangedEvent.key] = window.IPRestrictionsChangedEvent;
window.Events[window.PlaybookSavedEvent.key] = window.PlaybookSavedEvent;
window.Events[window.PlaybookPositionConfirmedEvent.key] = window.PlaybookPositionConfirmedEvent;
window.Events[window.PlaybookPositionDeclinedEvent.key] = window.PlaybookPositionDeclinedEvent;
window.Events[window.PlaybookWrittenPlaybookImportedEvent.key] = window.PlaybookWrittenPlaybookImportedEvent;
window.Events[window.PlaybookFormReadEvent.key] = window.PlaybookFormReadEvent;
window.Events[window.PlaybookNegotiationsImportedEvent.key] = window.PlaybookNegotiationsImportedEvent;
window.Events[window.PlaybookExportedEvent.key] = window.PlaybookExportedEvent;
window.Events[window.CreateNewConformedDealEvent.key] = window.CreateNewConformedDealEvent;
window.Events[window.SaveConformedDealEvent.key] = window.SaveConformedDealEvent;

(function() {
  function Track() {
    activityDetector.on('active', () => {
      window.track.event(new SessionStartEvent({}));
    });

    activityDetector.on('idle', () => {
      window.track.event(new SessionTimeoutEvent({}));
    });

    window.addEventListener("beforeunload", function(event) {
      window.track.event(new SessionEndEvent({}));

      if (window.lease && window.lease.form) {
        window.localStorage.setItem('last_session_form', JSON.stringify(window.lease.form));
      }
    });

    // Helper function to recursively sanitize string values in event data to prevent XSS
    function sanitizeEventData(obj) {
      if (!obj) return obj;
      
      if (typeof obj === 'string') {
        // Optimization: Only sanitize if string contains potentially malicious patterns
        // Check for Angular expressions ({{...}}) or HTML tags (<...>)
        if (!obj.includes('{{') && !obj.includes('<')) {
          // Plain text with no suspicious patterns - return as-is
          return obj;
        }
        
        // Remove Angular expressions and basic HTML from strings
        let sanitized = obj.replace(/{{.*?}}/g, '');
        sanitized = safeSanitize(sanitized, {
          allowedTags: [],
          allowedAttributes: [],
        });
        return sanitized;
      }
      
      if (Array.isArray(obj)) {
        return obj.map(item => sanitizeEventData(item));
      }
      
      if (typeof obj === 'object') {
        const sanitized = {};
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            sanitized[key] = sanitizeEventData(obj[key]);
          }
        }
        return sanitized;
      }
      
      return obj;
    }

    this.identify = () => {
      if (!window.user) {
        return;
      }

      let USER_COMPANY = "";

      if (window.user.company) {
        USER_COMPANY =  window.user.company.name;
      }

      const USER_EMAIL = window.user.email;
      const USER_ID = window.user.id;

      if (
        window._mixpanel_enabled && 
        typeof mixpanel !== "undefined"
      ) {
        mixpanel.identify(USER_ID);
      }

      if (typeof Raven !== "undefined") {
        Raven.setTagsContext({ company: USER_COMPANY });
        Raven.setUserContext({
          email: USER_EMAIL,
          id: USER_ID,
        });
      }
    };

    this.setProfile = () => {
      const USER_ID = window.user.id;

      if (
        window._mixpanel_enabled && 
        typeof mixpanel !== "undefined"
      ) {
        mixpanel.people.set({
          "USER_ID": USER_ID,
          "$email": window.user.email,
          "company": window.user.company.name,
          "name": window.user.firstName && window.user.lastName ? `${window.user.firstName} ${window.user.lastName}` : '',
          "role": window.user.role,
          "createdAt": window.user.createdAt,
          "updatedAt": window.user.updatedAt,
        });
      }
    };

    this.event = (event) => {
      if (typeof window.user === "undefined") {
        return;
      }

      if (window.isDebug) {
        console.log(event);
      }

      try {
        if (
          window._mixpanel_enabled &&
          typeof mixpanel !== "undefined" &&
          window.user &&
          !window.user.isLeasePilotUser
        ) {
          mixpanel.track(event.description, event.data);
        }

        if (
          window._wootric_enabled &&
          typeof wootric !== "undefined" &&
          window.user &&
          !window.user.isLeasePilotUser
        ) {
          const referer = document.referrer.replace(
            document.location.protocol + "//" + document.location.host,
            ""
          );

          if (
            event.key === "SHARE_DOCUMENT" ||
            event.key === "DOWNLOAD_DOCUMENT" ||
            (event.key === "LOAD_DASHBOARD" && referer.endsWith("/edit"))
          ) {
            let form;

            if (window.lease && window.lease.form) {
              form = window.lease.form;  
            } else {
              form = JSON.parse(window.localStorage.getItem('last_session_form'));
            }

            window.wootricSettings.properties = {};
            window.wootricSettings.properties.role = window.user.role;

            if (form) {
              window.wootricSettings.properties.product = form.product;
              window.wootricSettings.properties.industry = form.name.toLowerCase();
              window.wootricSettings.properties.formType = form.dealType;
            }

            wootric("run");
          }
        }

        let objectId;

        try {
          objectId = event.getObjectId();
        } catch(ex) {
          console.error(ex);
        } finally {
          let eventData = event.data ? JSON.parse(JSON.stringify(event.data).replace(/"(password|token|secret|key|auth|credential)"\s*:\s*"[^"]*"/gi, '"$1":"[REDACTED]"')) : null;
          // Sanitize event data to prevent XSS attacks before storing in database
          eventData = sanitizeEventData(eventData);
          
          const data = {
            event: {
              channel: event.channel,
              object_type: event.page,
              object_id: objectId,
              key: event.key,
              data: eventData,
              url: window.location.pathname,
              timestamp: new Date().toISOString()
            }
          }
          
          // Use sendBeacon for reliable event sending during page unload
          const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
          data.csrf_token = csrfToken;
          const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
          navigator.sendBeacon(`/api/events`, blob);
        }
      } catch(ex) {
        console.error(ex);
      }
    };
  }

  window.track = new Track();
})();
